export function GetBaseUrl() {
  return `${document.location.origin}${document.location.pathname}`;
}
